import styled from "styled-components";
import { SIZES } from "@/components/constants";
import { useLocale } from "next-intl";
import { useGetFaqQuery } from "@/api/helpApi";
import AccordionSection from "./AccordionSection";

const HelpSupportWrap = ({ langData }) => {
    const locale = useLocale();
    const { data, isLoading } = useGetFaqQuery({ locale });
    if (isLoading || !data || !data.result) return null;

    return (
        <HelpSupportWrapper>

            <AccordionSection
                title={langData["news-share-text"]}
                desc={langData["news-share-comment"]}
                list={data.data.esg}
            />

            <AccordionSection
                title={langData["faq-text"]}
                desc={langData["faq-comment"]}
                list={data.data.faq}
            />

        </HelpSupportWrapper>
    );
};

export default HelpSupportWrap;


const HelpSupportWrapper = styled.div`
    gap: 40px;
    display: flex;
    flex-direction: column;
    @media (min-width: ${SIZES.MOBILE_L}) {
        gap: 80px;
    }
    @media (min-width: ${SIZES.TABLET}) {
        gap: 80px;
    }
`;
